import { render, staticRenderFns } from "./AxPushNotificationsMentioned.vue?vue&type=template&id=0cce3316&"
import script from "./AxPushNotificationsMentioned.vue?vue&type=script&lang=ts&"
export * from "./AxPushNotificationsMentioned.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports